<template>
    <transition name="v-notification-fade">
        <div id="v-notification-bar" v-if="show" :class="status" class="alert alert-dismissable">
            <a href="#" class="close" @click.prevent="close" aria-label="close">
                <img :src="asset(`/assets/images/svg/close-icon${ status === 'warning' ? '-black' :'' }.svg`)" width="25" height="25" />
            </a>
            <h4>{{ title }}</h4>
            <p v-html="message" class="tw-mb-0"></p>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { watch, nextTick, withDefaults, defineProps, defineEmits } from "vue";

// Define props
interface Props {
  show: boolean;
  title: string;
  message: string;
  status?: string;
  closeOnKeyPress?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  status: "success",
  closeOnKeyPress: false,
});

// Define emits
const emit = defineEmits<{
  close: [];
}>();

// Methods
const close = () => {
  emit("close");
};

const handleMouseClick = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  close();
};

// Watch for show prop changes
watch(() => props.show, async (value) => {
  if (!value) {
    return;
  }

  // Wait for DOM update
  await nextTick();
  
  const element = document.getElementById("v-notification-bar");
  if (element) {
    element.removeEventListener("click", handleMouseClick);
    element.addEventListener("click", handleMouseClick);
  }
});
</script>

<style>
.v-notification-fade-enter-active {
    transition: all 0.3s ease-in;
}

.v-notification-fade-leave-active {
    transition: all 0.3s ease-out;
}

.v-notification-fade-enter-to,
.v-notification-fade-leave {
    opacity: 0.8;
    transform: translateY(0px);
}

.v-notification-fade-enter,
.v-notification-fade-leave-to {
    opacity: 0;
    transform: translateY(-90px);
}
</style>
